import { PhoneRefreshIcon } from './PhoneRefreshIcon';

/**
 * author: Michael Irigoyen
 * id F8A826E0-7094-488F-ADF4-ACC23B865B8E
 * name phone-refresh
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-refresh.svg
 * tags
 * - Cellphone / Phone 
 */
export const PhoneRedialIcon = PhoneRefreshIcon;
export default PhoneRedialIcon